import type * as Types from '../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { CuFieldsFragmentDoc } from '../../../graphql/gql-fragments/company-user.graphql';
import { UserFieldsFragmentDoc, UserFeaturePreferencesFieldsFragmentDoc } from '../../../graphql/gql-fragments/user.graphql';
import { CiFieldsFragmentDoc } from '../../../graphql/gql-fragments/company-invite.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlSettingsUsersQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlSettingsUsersQuery = { companyUsers: Array<{ id: string, userId: string, companyId: string, role: Types.GqlCompanyUserRole, createdAt: string, updatedAt: string, user: { id: string, admin: boolean, personalId?: string | null, name?: string | null, jwtEpoch: number, signInCount: number, unconfirmedEmail?: string | null, email?: string | null, emailMd5?: string | null, phone?: string | null, companySuggestionsSyncedDate?: string | null, communicationLanguage: string, currentSignInAt?: string | null, hubspotObjectId?: string | null, createdAt: string, updatedAt: string, referralSource?: Types.GqlReferralSource | null, referralSourceOther?: string | null } }>, companyInvites: Array<{ id: string, email?: string | null, role: Types.GqlCompanyUserRole, inviterName?: string | null, companyId: string, createdAt: string, updatedAt: string }>, companyInviteRequests: Array<{ id: string, role: Types.GqlCompanyUserRole, userId: string, userName?: string | null, userEmail?: string | null }> };


export const SettingsUsersDocument = gql`
    query SettingsUsers($companyId: ID!) {
  companyUsers(companyId: $companyId) {
    ...CuFields
    user {
      ...UserFields
    }
  }
  companyInvites(companyId: $companyId) {
    ...CiFields
  }
  companyInviteRequests(companyId: $companyId) {
    id
    role
    userId
    userName
    userEmail
  }
}
    ${CuFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${CiFieldsFragmentDoc}`;

/**
 * __useSettingsUsersQuery__
 *
 * To run a query within a React component, call `useSettingsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSettingsUsersQuery(baseOptions: Apollo.QueryHookOptions<GqlSettingsUsersQuery, GqlSettingsUsersQueryVariables> & ({ variables: GqlSettingsUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSettingsUsersQuery, GqlSettingsUsersQueryVariables>(SettingsUsersDocument, options);
      }
export function useSettingsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSettingsUsersQuery, GqlSettingsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSettingsUsersQuery, GqlSettingsUsersQueryVariables>(SettingsUsersDocument, options);
        }
export function useSettingsUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlSettingsUsersQuery, GqlSettingsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlSettingsUsersQuery, GqlSettingsUsersQueryVariables>(SettingsUsersDocument, options);
        }
export type SettingsUsersQueryHookResult = ReturnType<typeof useSettingsUsersQuery>;
export type SettingsUsersLazyQueryHookResult = ReturnType<typeof useSettingsUsersLazyQuery>;
export type SettingsUsersSuspenseQueryHookResult = ReturnType<typeof useSettingsUsersSuspenseQuery>;
export type SettingsUsersQueryResult = Apollo.QueryResult<GqlSettingsUsersQuery, GqlSettingsUsersQueryVariables>;